var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alpheios-ui-options__cont" },
    [
      _c("font-size"),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isMobile,
              expression: "!isMobile",
            },
          ],
          staticClass: "alpheios-ui-options__popup-size-item",
        },
        [
          _c(
            "label",
            {
              staticClass: "alpheios-ui-options__popup-size-item_top-label",
              attrs: { for: "alpheios-ui-options-popup-max-width" },
            },
            [_vm._v(_vm._s(_vm.uiOptions.items.maxPopupWidth.labelText))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.maxPopupWidth,
                expression: "maxPopupWidth",
              },
            ],
            attrs: {
              type: "range",
              id: "alpheios-ui-options-popup-max-width",
              name: "volume",
              min: _vm.uiOptions.items.maxPopupWidth.values.min,
              max: _vm.uiOptions.items.maxPopupWidth.values.max,
              step: _vm.uiOptions.items.maxPopupWidth.values.step,
            },
            domProps: { value: _vm.maxPopupWidth },
            on: {
              __r: function ($event) {
                _vm.maxPopupWidth = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "alpheios-ui-options__popup-size-item_bottom-label",
              attrs: { for: "alpheios-ui-options-popup-max-width" },
            },
            [
              _c(
                "span",
                {
                  staticClass:
                    "alpheios-ui-options__popup-size-item_bottom-label-item",
                },
                [_vm._v(_vm._s(_vm.uiOptions.items.maxPopupWidth.labels.min))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "alpheios-ui-options__popup-size-item_bottom-label-item",
                },
                [_vm._v(_vm._s(_vm.uiOptions.items.maxPopupWidth.labels.mid))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "alpheios-ui-options__popup-size-item_bottom-label-item",
                },
                [_vm._v(_vm._s(_vm.uiOptions.items.maxPopupWidth.labels.max))]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("setting", {
        attrs: {
          classes: ["alpheios-ui-options__item"],
          data: _vm.uiOptions.items.panelPosition,
        },
        on: { change: _vm.uiOptionChanged },
      }),
      _vm._v(" "),
      _c("setting", {
        attrs: {
          classes: ["alpheios-ui-options__item"],
          data: _vm.uiOptions.items.hideLoginPrompt,
        },
        on: { change: _vm.uiOptionChanged },
      }),
      _vm._v(" "),
      _c("setting", {
        attrs: {
          classes: ["alpheios-ui-options__item"],
          data: _vm.uiOptions.items.hidePopupOnClickAway,
        },
        on: { change: _vm.uiOptionChanged },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }